<template>
  <div class="c-user-edit">
    <n-loader :loading="$var('load')"></n-loader>
    <div class="container">
      <div class="header">
        <img :src="imgBackrow" alt="" @click="closeForm">
        <h1>{{ title }}</h1>
      </div>
      <div v-if="step === 0" class="input-place">
        <n-input v-bind="$form.input(this.field)" :placeholder="'Ввведите '+title" />
      </div>
      <div v-else class="email-code-input">
        <h3>Введите код присланный на вашу почту</h3>
        <c-code-input :code.sync="code" />
      </div>
    </div>
    <n-button v-if="step === 0" class="edit-user-button" :disabled="['', '+7'].includes($form.get(field))" @click="checkFunc">
      {{  'Сохранить' }}
    </n-button>
    <n-button v-else class="edit-user-button" :disabled="isBtnDisabled" @click="editEmail">Сохранить</n-button>
  </div>
</template>

<script>
import imgBackrow from 'assets/rows/bacrow.svg'
export default {
  name: 'CUserEdit',
  props: {
    title: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newValue: '',
      step: 0,
      isBtnDisabled: true,
      isEmail: false,
      code: '',
      imgBackrow,
    }
  },
  watch: {
    code() {
      this.isBtnDisabled = false
    },
  },
  created() {
    this.$form.init({
      [this.field]: '',
    })
    this.$form.rules({
      [this.field]: ['required'],
    })
    this.$form.masks({
      phone: ['phone'],
      emergencyContact: ['phone'],
    })
    if (['emergencyContact', 'phone'].includes(this.field)) {
      this.$form.set(this.field, '+7')
    }
  },
  methods: {
    checkFunc() {
      if (this.isEmail) {
        this.sendEmailCode()
      } else {
        this.editUser()
      }
    },
    sendEmailCode() {
      this.$var('load', true)
      $api.user.sendEmailCode().then(() => {
        this.step = 1
        this.isBtnDisabled = true
      }).finally(() => {
        this.$var('load', false)
      })
    },
    editEmail() {
      this.$var('load', true)
      $api.user.editEmail($app.auth.user().id, {
        code: this.code,
        email: this.form.get(this.field),
      }).then(() => {
        $app.store.action('app.updateUser').finally(() => {
        })
        this.closeForm()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    editUser() {
      this.$var('load', true)
      $api.user.edit($app.auth.user().id, { [this.field]: this.$form.get(this.field), }).then((response) => {
        $app.store.action('app.updateUser').finally(() => {})
        this.closeForm()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    closeForm() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-user-edit {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1001;
  padding-top: 50px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .email-code-input {
    margin-top: 25px;
     h3 {
       text-align: center;
       font-size: 1.3em;
       margin-bottom: 20px;
     }
  }

  .header {
    display: flex;
    align-items: center;
    h1 {
      font-size: 1.5em;
      font-weight: normal;
      margin: 0 auto;
    }
  }
  .input-place {
    margin-top: 50px;
  }
  .edit-user-button {
    margin: 0 25px 25px 25px;
    &::v-deep {
      .content {
        font-weight: bold;
        color: var(--secondary);
      }
    }
  }
}
</style>
